module.exports = __webpack_public_path__ + "img/img23.ab79f4a1.svg";